// DRF 400s for this feature are `{ field: ["translated string"] }` (or
// `detail` / `non_field_errors`), not `{ message }`. ApiService keeps the
// body on `error.response`; this picks the copy the backend already localized.

function firstDrfErrorMessage(value) {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || null;
  }
  if (Array.isArray(value)) {
    return value.map(firstDrfErrorMessage).find(Boolean) || null;
  }
  if (!value || typeof value !== 'object') {
    return null;
  }
  if (value.non_field_errors) {
    const nonField = firstDrfErrorMessage(value.non_field_errors);
    if (nonField) return nonField;
  }
  return (
    Object.keys(value)
      .filter((key) => key !== 'non_field_errors')
      .map((key) => firstDrfErrorMessage(value[key]))
      .find(Boolean) || null
  );
}

export default function getDrfErrorMessage(data) {
  if (typeof data === 'string') {
    return data.trim() || null;
  }
  if (!data || typeof data !== 'object') {
    return null;
  }
  if (typeof data.detail === 'string' && data.detail.trim()) {
    return data.detail.trim();
  }
  return firstDrfErrorMessage(data.detail) || firstDrfErrorMessage(data);
}
